import { Injectable } from '@angular/core';

/**
 * Native scroll-to service.
 * Replaces the deprecated `@nicky-lenaers/ngx-scroll-to` package.
 * Uses native `scrollIntoView()` for programmatic scrolling.
 */
@Injectable({
  providedIn: 'root'
})
export class ScrollToService {
  scrollTo(options: { target: string }): void {
    if (!options || !options.target) {
      return;
    }
    try {
      const element = document.querySelector(options.target);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch (e) {
      // Silently handle invalid selectors
    }
  }
}
